import { useTheme } from '@/lib/theme'

/** The site title, drawn differently by each theme. */
export function Brand() {
  const theme = useTheme((s) => s.theme)

  if (theme === 'newsprint') {
    return (
      <h1 className="display text-2xl min-[400px]:text-3xl sm:text-4xl">
        wordevery<span className="accent-text">.day</span>
      </h1>
    )
  }

  if (theme === 'arcade') {
    return (
      <h1 className="display flex gap-[3px] text-base min-[400px]:text-lg sm:text-2xl" aria-label="wordevery.day">
        {['W', 'O', 'R', 'D'].map((letter, i) => (
          <span
            key={letter}
            aria-hidden
            className="tile tile-board flex size-[1.6em] items-center justify-center"
            style={{ rotate: `${[-4, 3, -2, 4][i]}deg` }}
          >
            {letter}
          </span>
        ))}
        <span aria-hidden className="ml-1 self-center bg-gradient-to-r from-fuchsia-500 to-amber-400 bg-clip-text text-transparent">
          every.day
        </span>
      </h1>
    )
  }

  return (
    <div className="flex items-center gap-2 min-[400px]:gap-3">
      <span
        aria-hidden
        className="relative flex size-9 shrink-0 items-center justify-center rounded-xl bg-gradient-to-b from-emerald-400 to-emerald-600 text-xl font-black text-white shadow-[inset_0_-4px_0_rgb(0_0_0/0.2)] min-[400px]:size-11 min-[400px]:text-2xl"
      >
        W<span className="absolute right-1 bottom-0.5 text-[0.55rem] font-bold">4</span>
      </span>
      <h1 className="display text-lg min-[400px]:text-xl sm:text-2xl">
        wordevery<span className="text-emerald-600 dark:text-emerald-400">.day</span>
      </h1>
    </div>
  )
}
